import {
  eventListener,
  ISubscribeUserContext,
  IUserContext,
  TOPICS,
} from "@origin-digital/event-dispatcher";
import { useEffect, useRef } from "react";
import { shallowCopy } from "../utils/objects";

/**
 * Subscribe and unsubscribe to SUBSCRIBE_USER_CONTEXT events, respond to subscribers when the user context changes.
 */
export const useUserContextSubscriptionHandler = (
  userContext: IUserContext | undefined
): void => {
  const subscribersList = useRef<((user: IUserContext | undefined) => void)[]>(
    []
  );
  const userContextRef = useRef<IUserContext | undefined>(userContext);

  // on mount, listen for subscribers
  useEffect(() => {
    const handleSubscribeToUserContext = (event: ISubscribeUserContext) => {
      const { subscriber } = event.payload;
      subscribersList.current.push(subscriber);
      subscriber(shallowCopy(userContextRef.current));
      return () =>
        subscribersList.current.splice(
          subscribersList.current.indexOf(subscriber),
          1
        );
    };
    return eventListener.addListener(
      TOPICS.SUBSCRIBE_USER_CONTEXT,
      handleSubscribeToUserContext
    );
  }, []);

  useEffect(() => {
    userContextRef.current = userContext;
    subscribersList.current.forEach((subscriber) => {
      subscriber(shallowCopy(userContextRef.current));
    });
  }, [userContext]);
};
